import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SmallButton from 'Components/Button/SmallButton';
import HollowButton from 'Components/Button/HollowButton';
import classnames from 'classnames';
import './MessageView.scss';

const MessageView = class extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isExpanded: false,
    };

    this.attachBindings();
  }

  attachBindings() {
    this.viewAction = this.viewAction.bind(this);
  }

  viewAction() {
    this.setState({
      isExpanded: !this.state.isExpanded,
    });
  }

  render() {
    const {
            description,
            primaryAction,
            primaryActionText,
            messageId,
        } = this.props;

    const secondaryActionText = this.state.isExpanded === true ? 'Collapse' : 'View';

    const cardDesc = classnames('card__description', {
      'card__description--expanded': this.state.isExpanded,
    });

    const cardRight = classnames('card__rightside-wrap', {
      'card__rightside-wrap--expanded': this.state.isExpanded,
    });

    const cardLeft = classnames('card__leftside-wrap', {
      'card__leftside-wrap--expanded': this.state.isExpanded,
    });

    return (

      <div id="card-report-id" className="card report">
        <div className={cardLeft}>
          <span id="card__description-id" className={cardDesc}>{description}</span>
        </div>
        <div id="card__rightside-wrap-id" className={cardRight}>
          <HollowButton
            action={this.viewAction}
            className="view-button"
          >
            {secondaryActionText}
          </HollowButton> <div>&nbsp;&nbsp;</div>
          <SmallButton action={primaryAction}>
            {primaryActionText}
          </SmallButton>
        </div>
      </div>
    );
  }
};

MessageView.propTypes = {
  shareableUsers: PropTypes.array,
  description: PropTypes.string,
  primaryAction: PropTypes.func,
  primaryActionText: PropTypes.string,
  cardType: PropTypes.string,
  exportAction: PropTypes.func,
  exportList: PropTypes.array,
  fileList: PropTypes.array,
  getReportUserFilters: PropTypes.func,
  isDraft: PropTypes.bool,
  isNew: PropTypes.bool,
  ownerName: PropTypes.string,
  savedFilters: PropTypes.array,
  selectedInput: PropTypes.object,
  secondaryOptions: PropTypes.array,
  scheduleList: PropTypes.array,
  sharingUsers: PropTypes.array,
  translations: PropTypes.object,
  triggerToast: PropTypes.func,
  updateSharing: PropTypes.func,
};

MessageView.defaultProps = {
  shareableUsers: [],
  cardType: '',
  description: '',
  exportAction: null,
  exportList: [
    {
      value: 'visible-columns',
      text: 'Visible Columns',
    },
    {
      value: 'all-columns',
      text: 'All Columns',
    },
  ],
  fileList: [
    {
      value: 'csv',
      text: 'CSV',
    },
    {
      value: 'pdf',
      text: 'PDF',
    },
  ],
  getReportUserFilters: null,
  isDraft: false,
  isNew: false,
  ownerName: '',
  savedFilters: [],
  selectedInput: {
    value: '',
    text: '',
    action: () => { },
  },
  secondaryOptions: [],
  scheduleList: [],
  sharingUsers: [],
  translations: {
    apply: 'Export',
    cancel: 'Cancel',
    draft: 'Draft',
    exportText: 'Export',
    exportingText: 'Exporting',
    exportTypesTitle: 'What do you want to export?',
    fileNameLabel: 'File Name',
    fileTypesTitle: 'Save As:',
    header: 'Export Options',
    more: 'More',
    new: 'New',
    reportOwner: 'Owner:',
    triggerText: 'Export',
    exportReport: 'Export Report',
    viewReport: 'View Report',
    emptySavedFilter: {
      title: 'A Saved Filter is required',
      subTitle: 'It looks like you don\'t have any saved filters to export this report.',
    },
  },
  triggerToast: () => { },
  updateSharing: null,
};

export default MessageView;
